export default __webpack_public_path__ + "static/media/layer-controls-arrange.f5376892.svg";